// extracted by mini-css-extract-plugin
module.exports = {"container":"app-links_container__2qcw5","link":"app-links_link__VjvDv"};